import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "单向箭头",
  "use": "单向箭头-usage",
  "viewBox": "0 0 3481 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 3481 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"单向箭头\"><path d=\"M2443.6736 614.4L2048 282.4192 2284.9536 0l1171.456 983.04H0V614.4h2443.6736z\" p-id=\"2140\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol